<%= form_with(model: heat, class: "contents") do |form| %>
  <% if heat.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(heat.errors.count, "error") %> prohibited this heat from being saved:</h2>

      <ul class="list-disc ml-6">
        <% heat.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :dance_id %>
    <%= form.text_field :dance_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:dance_id].none?, "border-red-400 focus:outline-red-600": heat.errors[:dance_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :entry_id %>
    <%= form.text_field :entry_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:entry_id].none?, "border-red-400 focus:outline-red-600": heat.errors[:entry_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :number %>
    <%= form.text_field :number, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:number].none?, "border-red-400 focus:outline-red-600": heat.errors[:number].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :ballroom %>
    <%= form.text_field :ballroom, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:ballroom].none?, "border-red-400 focus:outline-red-600": heat.errors[:ballroom].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :category %>
    <%= form.text_field :category, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:category].none?, "border-red-400 focus:outline-red-600": heat.errors[:category].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :prev_number %>
    <%= form.text_field :prev_number, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": heat.errors[:prev_number].none?, "border-red-400 focus:outline-red-600": heat.errors[:prev_number].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
